// extracted by mini-css-extract-plugin
export default {"Loader":"Spinner_Loader__FMNhK","spin":"Spinner_spin__WXrZi"};